import observeIntersection from "./frontend/observeIntersection";
const handleCollapse = () =>{
    const lists = document.querySelectorAll('.ume-intra-agenda-block-list');
    if(lists.length > 0){
        const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        lists.forEach(list => {
            let trigger = list.querySelector('.btn.btn-link');
            let content = list.querySelector('.collapse');
            if(vw > 995){
                trigger.setAttribute('aria-expanded', 'true');
                content.classList.add('show');
            }
            if(vw <= 995){
                trigger.setAttribute('aria-expanded', 'false');
                content.classList.remove('show');
            }

        })
    }
}
window.addEventListener('load', () => {
    observeIntersection();
    handleCollapse();





});

let currentWidth = window.innerWidth;
window.addEventListener('resize', () => {
    if (currentWidth === window.innerWidth) return;
    handleCollapse();
    currentWidth = window.innerWidth;

});
window.addEventListener('orientationchange', function () {
    handleCollapse();
});